export const commentInvite = (commentInvite) => {
  return {
    type : 'COMMENT_INVITE',
    commentInvite
  }
}; 
 